var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "@irati/ui/src/Flex";
export default styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :not(:last-child) {\n    border-bottom: solid 1px ", ";\n    padding-bottom: 13px;\n  }\n\n  :not(:first-child) {\n    padding-top: 11px;\n  }\n"], ["\n  :not(:last-child) {\n    border-bottom: solid 1px ", ";\n    padding-bottom: 13px;\n  }\n\n  :not(:first-child) {\n    padding-top: 11px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.light;
});
var templateObject_1;
